import { Skeleton } from 'antd'

import styles from './statsBar.module.scss'

export type StatTone = 'default' | 'brand' | 'active' | 'muted'

export type StatItem = {
  label: string
  value: number | null
  tone: StatTone
}

type StatsBarProps = {
  items: StatItem[]
}

export const StatsBar = ({ items }: StatsBarProps) => (
  <div className={styles.bar}>
    {items.map((item) => (
      <div key={item.label} className={styles.stat}>
        {item.value === null ? (
          <Skeleton.Button active size='small' className={styles.skeleton} />
        ) : (
          <span className={`${styles.num} ${styles[item.tone]}`}>{item.value}</span>
        )}
        <span className={styles.label}>{item.label}</span>
      </div>
    ))}
  </div>
)
